import { AnalyticsService } from '@geovelo-frontends/commons';

import { environment } from '../environment';

AnalyticsService.init(environment.amplitude.apiKey);
